import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import template from './logo-and-profile-photo.html';
import { MySiteRestService } from '@nuskin/my-site-api';
import { MySiteApp, OverwritePaperRadioButtonStyles } from '../../my-site-app';
import { TdcStrings, nuskin } from '@nuskin/ns-util';

/**
 * @customElement
 * @polymer
 */
export class LogoAndProfilePhoto extends PolymerElement {

    constructor() {
        super();
        // eslint-disable-next-line no-undef
        let context = translationService.getCurrentContext();
        // eslint-disable-next-line no-undef
        this.content = translationService.getTranslations(context);

        // pass save method to form wrapper
        this.parentNode.saveForm = this.save();
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get is() {
        return 'logo-and-profile-photo';
    }

    static get properties() {
        return {
            useDefaultLogos: {
                type: Boolean,
                observer: '_handleUseDefaultChange'
            }
        }
    }

    ready() {
        super.ready();
        this.$.profilePhoto.addEventListener('ns-image-upload-result', this._handleProfileImageUploader.bind(this));
        this.$.profilePhoto.addEventListener('ns-image-upload-remove', this._handleImageUploaderRemove.bind(this));
        this.$.siteLogo.addEventListener('ns-image-upload-result', this._handleLogoImageUploader.bind(this));
        this.$.siteLogo.addEventListener('ns-image-upload-remove', this._handleImageUploaderRemove.bind(this));
        this.overwritePaperRadioButtonStyles();
    }

    connectedCallback() {
        this.mySite = document.querySelector(MySiteApp.is);
        this.mySite.addEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
    }

    disconnectedCallback() {
        this.mySite.removeEventListener('my-site-data-changed', this._subscribeToMySiteDataChanges.bind(this));
        this.$.profilePhoto.removeEventListener('ns-image-upload-result', this._handleProfileImageUploader.bind(this));
        this.$.profilePhoto.removeEventListener('ns-image-upload-remove', this._handleImageUploaderRemove.bind(this));
        this.$.siteLogo.removeEventListener('ns-image-upload-result', this._handleLogoImageUploader.bind(this));
        this.$.siteLogo.removeEventListener('ns-image-upload-remove', this._handleImageUploaderRemove.bind(this));
    }

    _handleUseDefaultChange(newVal) {
        if(newVal) {
            this.$.useDefaultLogos.checked = true;
            this.$.useCustomLogos.checked = false;
            this.parentNode.updateAndNotify(this.defaultLogos.profile, false, false, 'profilePhoto');
            this.parentNode.updateAndNotify(this.defaultLogos.site, false, false, 'siteLogo');
        } else {
            this.$.useDefaultLogos.checked = false;
            this.$.useCustomLogos.checked = true;
            this.parentNode.updateAndNotify(this.mySite.mySiteData.profilePhoto, false, false, 'profilePhoto');
            this.parentNode.updateAndNotify(this.mySite.mySiteData.siteLogo, false, false, 'siteLogo');
        }

        if(this.siteLogo === this.defaultLogos.site)
            this.$.siteLogo.removeAttribute('circle');
        else
            if(!this.$.siteLogo.hasAttribute('circle'))
                this.$.siteLogo.setAttribute('circle', true);

        this.$.siteHeaderUploader.style.display = newVal ? 'none' : 'block';

        this.parentNode.updateAndNotify(newVal, false, false, 'useDefaultLogos');

        if(!this.useDefaultLogos && (!this.profilePhoto))
            this.parentNode.setFormValidity(false);
        else 
            this.parentNode.setFormValidity(true);
    }

    async getDefaultLogos() {
        if(!this.defaultLogos) {
            let mySiteTranslationsNonTdc = await TdcStrings.getNonTdcStrings('mysite/mysite-home', this.mySite.currentLanguage,  this.mySite.currentMarket)
            this.defaultLogos = {
                site: mySiteTranslationsNonTdc.welcomeSectionLogoImageReference,
                profile: mySiteTranslationsNonTdc.welcomeSectionProfileImageReference
            }
        }
    }

    async _subscribeToMySiteDataChanges(){
        await this.getDefaultLogos();
        if(this.mySite.currentForm !== LogoAndProfilePhoto.is) return;
        this.set('data', this.mySite.mySiteData);
        this.set('siteLogo', this.data.siteLogo);
        this.set('profilePhoto', this.data.profilePhoto);
        this.set('useDefaultLogos', this.data.useDefaultLogos);

        if(this.siteLogo === this.defaultLogos.site)
            this.$.siteLogo.removeAttribute('circle');
        else
            if(!this.$.siteLogo.hasAttribute('circle'))
                this.$.siteLogo.setAttribute('circle', true);
        
    }

    overwritePaperRadioButtonStyles() {
        OverwritePaperRadioButtonStyles(this.$.useDefaultLogos);
        OverwritePaperRadioButtonStyles(this.$.useCustomLogos);
    }

    _handleProfileImageUploader(e) {
        this.uploadImage(e, 'profilePhoto');
    }

    _handleLogoImageUploader(e){
        this.uploadImage(e, 'siteLogo');
    }

    uploadImage(e, whichImage) {
        let key = '_large';
        let file = e.detail[key]
        this[whichImage+'File'] = file
  
        let reader = new FileReader();
        reader.onloadend = () => {
            this.data[whichImage] = reader.result;
            this[whichImage] = reader.result;
            this.parentNode.updateAndNotify(this.data[whichImage], false, false, whichImage, true);
            this.parentNode.formTouched();
            if(!this.useDefaultLogos && !this.profilePhoto)
                this.parentNode.setFormValidity(false);
            else {
                this.parentNode.setFormValidity(true);
            }
        }
        reader.readAsDataURL(file);
    }

    _handleDefaultLogosClick() {
        this.useDefaultLogos = true;
        this.$.useDefaultLogos.checked = true;
        this.$.useCustomLogos.checked = false;
        this.parentElement.formTouched();
    }

    _handleCustomLogosClick() {
        this.useDefaultLogos = false;
        this.$.useDefaultLogos.checked = false;
        this.$.useCustomLogos.checked = true;
        this.parentElement.formTouched();
    }

    async _handleImageUploaderRemove(e) {
        let whichImage = e.currentTarget.id;
        this[whichImage] = '';

        this.parentNode.updateAndNotify(this[whichImage], false, false, whichImage, true);
        this.parentNode.formTouched();

        if(!this.useDefaultLogos && !this.profilePhoto)
            this.parentNode.setFormValidity(false);
        else {
            this.parentNode.setFormValidity(true);
        }

        if(this.siteLogo === this.defaultLogos.site)
            this.$.siteLogo.removeAttribute('circle');
        else
            if(!this.$.siteLogo.hasAttribute('circle'))
                this.$.siteLogo.setAttribute('circle', true);
    }

    // must be present to allow `form-wrapper` save the form
    save() {
        let that = this;
        return function() {
            // GA
            try {
                nuskin.events.publish(nuskin.events.mySite.SECTION_DATA_UPDATE, {
                    mySite: {
                        section: LogoAndProfilePhoto.is,
                        changed: {
                            profilePhoto: that.profilePhoto,
                            siteLogo: that.siteLogo,
                            useDefault: that.useDefaultLogos
                        }
                    }
                });
            } catch(err) {console.log(err)}

            return MySiteRestService.saveMySiteLogos(
                that.profilePhoto || that.defaultLogos.profile,
                that.siteLogo || that.defaultLogos.site,
                that.useDefaultLogos
            );
        };
    }

}

window.customElements.define(LogoAndProfilePhoto.is, LogoAndProfilePhoto);
